@if (company) {
   <div class="main-page-wrapper">

      <header class="company-header" style="padding: 0 0 1em 0;">
         <div class="flex-row flex-dynamic justify-flex-end wrappable"></div>
      </header>



      <!-- Page sections start here -->
      <section class="single-page-section grid-layout grid-entity-header">
         <div class="grid-card main-info-card">
            <div class="card-header">
               <div class="flex-row justify-space-between align-center width-full">
                  <h3 class="card-header-title">{{'COMPANY_SETTINGS' | trans }}</h3>
                  <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 6px;">
                     <strong class="company-title">{{ company.name }}</strong>
                  </div>
               </div>
            </div>

            <div class="card-body flex-row" style="gap: .5em;">
               <img [src]="company_logo" style="width: 128px; height: 128px; object-fit: contain;" />

               <div class="flex-column flex-dynamic">
                  <div>{{ company.address }}</div>
                  <div>{{ company.city }}</div>
                  <div>{{ company.country }}</div>
                  <div>{{ company.contact_phone }}</div>
               </div>
            </div>

         </div>

         @if (COMPANY_RIGHTS.insurers !== 0) {
            <div class="grid-card linked-entity-card">
               <div class="card-header">
                  <h3 class="card-header-title">{{"COMPANY_SETTINGS.INSURERS" | trans}}</h3>
                  @if (COMPANY_RIGHTS.insurers == 2) {
                     <button  class="add-btn round filled"
                        color="primary"
                        [attr.tooltip-left]="'ADD_NEW_INSURER' | trans"
                        (click)="add_insurer()">
                        <i icon="add"></i>
                     </button>
                  }
               </div>

               <div class="card-body flex-column wrappable align-flex-start" style="margin-bottom: 1.5rem; gap: .6em;">

                  @for (insurer of company.insurers; track insurer; let i = $index) {
                     <div class="flex-row align-center" style="gap: 0.1rem;" >
                        <strong class="grid-card" style="min-height: auto; padding: 0.5rem;">{{insurer}}</strong>

                        <button class="delete-btn round table-button"
                           style="margin: 0;"
                           color="warn"
                           (click)="delete_insurer(insurer)"
                           [attr.tooltip-right]="'DELETE' | trans"
                        >
                           <i icon="clear"></i>
                        </button>
                     </div>
                  }

                  @for (insurer of new_insurers; track i; let i = $index) {
                     <div class="flex-row align-center" style="gap: 0.2rem;" >
                        <label class="input">
                           <input type="text" class="input" [(ngModel)]="new_insurers[i]" placeholder="Upiši naziv kuće" />
                        </label>

                        <button class="delete-btn round table-button"
                           style="margin: 0;"
                           color="warn"
                           (click)="new_insurers.splice(i, 1)"
                           [attr.tooltip-right]="'DELETE' | trans"
                        >
                           <i icon="clear"></i>
                        </button>

                        <button class="save-btn round table-button"
                           style="margin: 0;"
                           color="secondary-dark"
                           (click)="save_new_insurer(new_insurers[i])"
                           [attr.tooltip-right]="'SAVE' | trans"
                           [disabled]="new_insurers[i].trim() === ''"
                        >
                           <i icon="check"></i>
                        </button>
                     </div>

                  }

               </div>
            </div>
         }

      </section>

   </div>
}
